import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=1b76859a&scoped=true&"
import script from "./Reminders.vue?vue&type=script&lang=js&"
export * from "./Reminders.vue?vue&type=script&lang=js&"
import style0 from "./Reminders.vue?vue&type=style&index=0&id=1b76859a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b76859a",
  null
  
)

export default component.exports